import { useTranslation } from 'react-i18next';

import { CustomFieldType } from 'src/store/clients/types';

export const AllClientSelectValue = 'default';

export const COPYABLE_FIELDS_TYPES: Array<CustomFieldType> = [
  'url',
  'email',
  'text',
  'number',
  'phoneNumber',
];

export const getNewClientCreateOptions = (
  t: ReturnType<typeof useTranslation>['t'],
) => ({
  // legacy crm new button options
  CREATE_ONE_CLIENT: `Create one ${t('client_one')}`,
  IMPORT_MANY_CLIENTS: `Import many ${t('client_many')}`,
  // new crm new button options
  CREATE_CLIENT: t('actions.create_client'),
  CREATE_COMPANY: t('actions.create_company'),
  IMPORT: t('common.import'),
  COPY_SIGNUP_LINK: t('actions.copy_client_signup_link'),
});
